var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "life-box" }, [
    _vm.baseData.localLife1 && _vm.baseData.localLife1.enable == 1
      ? _c(
          "div",
          {
            staticClass: "home-top",
            style: {
              backgroundImage: "url(" + _vm.baseData.localLife1.pic + ")",
              backgroundSize: "cover",
            },
            on: {
              mouseover: function ($event) {
                return _vm.bothMouseOver(1)
              },
            },
          },
          [
            _vm.boole1
              ? _c(
                  "div",
                  {
                    staticClass: "cover",
                    on: {
                      mouseleave: function ($event) {
                        return _vm.bothMouseLeave(1)
                      },
                    },
                  },
                  [
                    _c("el-button", {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-edit",
                        size: "mini",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.bothClick(1)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _c("i", {
                  staticClass: "el-icon-location-outline",
                  style: { color: _vm.baseData.localLife1.textColor },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    style: {
                      fontSize: "14px",
                      marginLeft: "8px",
                      color: _vm.baseData.localLife1.textColor,
                    },
                  },
                  [_vm._v("杭州 >")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ipt", staticStyle: { height: "30px" } }, [
              _c("img", {
                staticStyle: { width: "14px", height: "14px", margin: "0 7px" },
                attrs: { src: require("@/assets/search.png") },
              }),
              _vm._v(" "),
              _c("span", { staticStyle: { "font-size": "10px" } }, [
                _vm._v(_vm._s(_vm.baseData.localLife1.searchInfo)),
              ]),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.baseData.localLife2 && _vm.baseData.localLife2.enable == 1
      ? _c(
          "div",
          {
            staticClass: "both-box",
            on: {
              mouseover: function ($event) {
                return _vm.bothMouseOver(2)
              },
            },
          },
          [
            _vm.boole2
              ? _c(
                  "div",
                  {
                    staticClass: "cover",
                    on: {
                      mouseleave: function ($event) {
                        return _vm.bothMouseLeave(2)
                      },
                    },
                  },
                  [
                    _c("el-button", {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-edit",
                        size: "mini",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.bothClick(2)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-carousel",
              {
                staticStyle: { background: "#d8d8d8", "border-radius": "15px" },
                attrs: {
                  arrow: "never",
                  height: "85px",
                  "indicator-position": "none",
                },
              },
              _vm._l(
                _vm.baseData.localLife2.bannerList &&
                  _vm.baseData.localLife2.bannerList.length > 0
                  ? _vm.baseData.localLife2.bannerList
                  : 5,
                function (item, index) {
                  return _c(
                    "el-carousel-item",
                    { key: index },
                    [
                      item.pic
                        ? _c("el-image", {
                            staticStyle: { width: "100%", height: "100%" },
                            attrs: { src: item.pic, fit: "fill" },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }
              ),
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.baseData.localLife3 && _vm.baseData.localLife3.enable == 1
      ? _c(
          "div",
          {
            staticClass: "home-second-top",
            on: {
              mouseover: function ($event) {
                return _vm.bothMouseOver(3)
              },
            },
          },
          [
            _vm.boole3
              ? _c(
                  "div",
                  {
                    staticClass: "cover",
                    on: {
                      mouseleave: function ($event) {
                        return _vm.bothMouseLeave(3)
                      },
                    },
                  },
                  [
                    _c("el-button", {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-edit",
                        size: "mini",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.bothClick(3)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "diamond", staticStyle: { padding: "10px 20px" } },
              [
                _c(
                  "div",
                  { staticClass: "diamond-box" },
                  _vm._l(
                    _vm.baseData.localLife3.bannerList &&
                      _vm.baseData.localLife3.bannerList.length > 0
                      ? _vm.baseData.localLife3.bannerList
                      : 10,
                    function (item, index) {
                      return _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: index <= 9,
                              expression: "index<=9",
                            },
                          ],
                          key: index,
                          staticClass: "diamond-son",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "small-box",
                              staticStyle: { position: "relative" },
                            },
                            [
                              item.pic
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%",
                                    },
                                    attrs: { src: item.pic, fit: "fill" },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              item.tagFlag === 1
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "15px",
                                      height: "15px",
                                      position: "absolute",
                                      right: "-12px",
                                      top: "-8px",
                                    },
                                    attrs: { src: item.tag, fit: "fill" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "text" }, [
                            _vm._v(_vm._s(item.name ? item.name : "自定义")),
                          ]),
                        ]
                      )
                    }
                  ),
                  0
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.baseData.localLife4 && _vm.baseData.localLife4.enable == 1
      ? _c(
          "div",
          {
            staticClass: "l-Three-box",
            on: {
              mouseover: function ($event) {
                return _vm.bothMouseOver(4)
              },
            },
          },
          [
            _vm.boole4
              ? _c(
                  "div",
                  {
                    staticClass: "cover",
                    on: {
                      mouseleave: function ($event) {
                        return _vm.bothMouseLeave(4)
                      },
                    },
                  },
                  [
                    _c("el-button", {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-edit",
                        size: "mini",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.bothClick(4)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                },
              },
              _vm._l(
                _vm.baseData.localLife4.bannerList &&
                  _vm.baseData.localLife4.bannerList.length > 0
                  ? _vm.baseData.localLife4.bannerList
                  : 2,
                function (item, index) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: index <= 2,
                          expression: "index<=2",
                        },
                      ],
                      key: index,
                      staticClass: "l-box",
                    },
                    [
                      item.pic
                        ? _c("el-image", {
                            staticStyle: {
                              width: "100%",
                              "border-radius": "15px",
                            },
                            attrs: { src: item.pic, fit: "fill" },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }
              ),
              0
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.baseData.localLife5 && _vm.baseData.localLife5.enable == 1
      ? _c(
          "div",
          {
            staticClass: "l-two-box",
            on: {
              mouseover: function ($event) {
                return _vm.bothMouseOver(5)
              },
            },
          },
          [
            _vm.boole5
              ? _c(
                  "div",
                  {
                    staticClass: "cover",
                    on: {
                      mouseleave: function ($event) {
                        return _vm.bothMouseLeave(5)
                      },
                    },
                  },
                  [
                    _c("el-button", {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-edit",
                        size: "mini",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.bothClick(5)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                },
              },
              _vm._l(
                _vm.baseData.localLife5.bannerList &&
                  _vm.baseData.localLife5.bannerList.length > 0
                  ? _vm.baseData.localLife5.bannerList
                  : 2,
                function (item, index) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: index <= 1,
                          expression: "index<=1",
                        },
                      ],
                      key: index,
                      staticClass: "l-box",
                    },
                    [
                      item.pic
                        ? _c("el-image", {
                            staticStyle: {
                              width: "100%",
                              height: "100%",
                              "border-radius": "15px",
                            },
                            attrs: { src: item.pic, fit: "fill" },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }
              ),
              0
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.baseData.localLife6 && _vm.baseData.localLife6.enable == 1
      ? _c(
          "div",
          {
            staticClass: "both-box",
            on: {
              mouseover: function ($event) {
                return _vm.bothMouseOver(6)
              },
            },
          },
          [
            _vm.boole6
              ? _c(
                  "div",
                  {
                    staticClass: "cover",
                    on: {
                      mouseleave: function ($event) {
                        return _vm.bothMouseLeave(6)
                      },
                    },
                  },
                  [
                    _c("el-button", {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-edit",
                        size: "mini",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.bothClick(6)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-carousel",
              {
                staticStyle: { background: "#d8d8d8", "border-radius": "15px" },
                attrs: {
                  arrow: "never",
                  height: "85px",
                  "indicator-position": "none",
                },
              },
              _vm._l(
                _vm.baseData.localLife6.bannerList &&
                  _vm.baseData.localLife6.bannerList.length > 0
                  ? _vm.baseData.localLife6.bannerList
                  : 5,
                function (item, index) {
                  return _c(
                    "el-carousel-item",
                    { key: index },
                    [
                      item.pic
                        ? _c("el-image", {
                            staticStyle: { width: "100%", height: "100%" },
                            attrs: { src: item.pic, fit: "fill" },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }
              ),
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.baseData.localLife7 && _vm.baseData.localLife7.enable == 1
      ? _c(
          "div",
          {
            staticClass: "both-box",
            on: {
              mouseover: function ($event) {
                return _vm.bothMouseOver(7)
              },
            },
          },
          [
            _vm.boole7
              ? _c(
                  "div",
                  {
                    staticClass: "cover",
                    on: {
                      mouseleave: function ($event) {
                        return _vm.bothMouseLeave(7)
                      },
                    },
                  },
                  [
                    _c("el-button", {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-edit",
                        size: "mini",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.bothClick(7)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                },
              },
              _vm._l(
                _vm.baseData.localLife7.bannerList &&
                  _vm.baseData.localLife7.bannerList.length > 0
                  ? _vm.baseData.localLife7.bannerList
                  : 4,
                function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticStyle: {
                        "border-radius": "3px",
                        width: "24%",
                        "background-color": "#d8d8d8",
                        height: "70px",
                      },
                    },
                    [
                      item.pic
                        ? _c("el-image", {
                            staticStyle: { width: "100%", height: "100%" },
                            attrs: { src: item.pic, fit: "fill" },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }
              ),
              0
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }